import { ReactNode } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export interface SEOProps {
  title: string
  children?: ReactNode
}

export const SEO = (props: SEOProps) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <title>{`${props.title} | ${data.site.siteMetadata.title}`}</title>

      {/* TODO: other seo tags write here */}

      {props.children}
    </>
  )
}
